module.exports = __webpack_public_path__ + "img/investing.46062def.svg";